import { render, staticRenderFns } from "./IconLoader.vue?vue&type=template&id=3ea71a92"
import script from "./IconLoader.vue?vue&type=script&lang=js"
export * from "./IconLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports